// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"505":"73a26f6f","618":"039ca116","891":"cf8e905f"}[chunkId] + ".chunk.css";
};